module.exports = __webpack_public_path__ + "static/media/PictureIcon.5b656a1d.svg";